import { propOr } from 'ramda';
import { IRealtyValuation } from '../../types/realtyValuation';
import { IApplicationState } from '../../types/redux';

export function getRealtyValuation(state: IApplicationState): IRealtyValuation | null {
  return propOr(null, 'realtyValuation', state);
}
